import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@app/common/utilities';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(value: Date, time: boolean = true): string {

    if (!value) { return ''; }

    let date: Date;
    if (typeof value === 'string') {
      date = new Date(value);
      if (isNaN(date.getTime())) {
        console.error('Invalid date format');
        return 'Invalid date';
      }
    } else {
      date = value;
    }

    const browserLanguage = Utilities.getBrowserDefaultLanguage();
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };

    if (time) {
      options.hour = '2-digit';
      options.hour12 = true;
    }

    const formatter = new Intl.DateTimeFormat(browserLanguage, options);
    const parts = formatter.formatToParts(date);

    let formattedDate = '';
    parts.forEach((part) => {
      if (part.type === 'month') {
        formattedDate += part.value ;
      } else if (part.type === 'day' || part.type === 'year' || part.type === 'hour') {
        formattedDate += ' ' + part.value + ' ';
      } else if (part.type === 'dayPeriod') {
        formattedDate += part.value.toUpperCase();
      }
    });

    formattedDate = this.addCommaAtSecondSpace(formattedDate.trim());
    if (time) {
      return formattedDate.replace(/ at /gi, ' ');
    } else {
      return formattedDate;
    }

  }

  private addCommaAtSecondSpace(dateString: string): string {
    let spaceCount = 0;
    let result = '';

    for (let i = 0; i < dateString.length; i++) {
      if (dateString[i] === ' ') {
        spaceCount++;
        if (spaceCount === 2) {
          result += ',';
        }
      }
      result += dateString[i];
    }

    return result;
  }
}
@NgModule({
  declarations: [FormatDatePipe],
  exports: [FormatDatePipe],
})
export class FormatDateModule { }
